import React from "react";

export default function GettingStarted() {
  return (
    <>
      <div className="fq-faq-area fq-faq-bdr  pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <h1 className="text-color-yellow bold-text">
                Getting Started with Kryptogram
              </h1>
              <div className="fq-faq-wrapper">
                <div className="tp-service-2-accordion-box">
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse20"
                          aria-expanded="true"
                          aria-controls="collapse20"
                        >
                          How do I buy my Kryptogram NFT? <br />
                          <br />
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse20"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <div class="service-details__fea-list">
                            <ul>
                              <li>
                                Step 1: Visit the Tribe O Crypto NFT
                                marketplace.
                              </li>
                              <li>
                                Step 2: Connect your crypto wallet securely.
                              </li>
                              <li>
                                Step 3: Purchase your Kryptogram NFT to unlock
                                exclusive benefits.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse21"
                          aria-expanded="false"
                          aria-controls="collapse21"
                        >
                          When will NFT staking and yield farming launch?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse21"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Staking and yield farming will be introduced in
                            early 2026 as part of Kryptogram’s blockchain
                            ecosystem expansion.
                          </p>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
